import { useCallback } from "react";
import { Box, Typography, Button, Avatar, Link } from "@mui/material";
import { UserEditIcon } from "../../assets/reactIcons";
import { Talent, User } from "../../../types/user";
import RatingNReview from "./RatingNReview";
import "./TalentInfo.scss";
import { Icons } from "../../assets/icon";
import { useCurrentTalentProfile } from "../../../hooks/useProfile";
import { useGetCategories } from "../../../services/api/card.api";
import { CategoriesValue } from "../../../types/Card";
import { getCurrentPageUrl } from "../../../utils/getCurrentPageUrl";

export default function TalentInfo({
  talentInfo,
  userInfo,
  onShareClick,
  shareableSlug,
}: {
  talentInfo: Talent;
  userInfo: User;
  onShareClick: () => void;
  shareableSlug?: () => string;
}) {
  const { currentProfile } = useCurrentTalentProfile();
  const { data: categories } = useGetCategories({ key: ["categories"] });
  const categoryList: CategoriesValue[] = categories?.data || [];

  const getCategoryLabel = (cat: string) =>
    categoryList.find((c) => c.slug === cat)?.name;

  return (
    <Box
      className="talent-info-container"
      sx={{
        // graceful fallback if CSS isn’t injected yet
        backgroundColor: "#141414",
        color: "#ffffff",
        borderRadius: 3,
        border: "1px solid rgba(255,255,255,0.12)",
        boxShadow: "0 16px 40px rgba(0,0,0,0.45)",
      }}
    >
      <Box className="talent-info-wrapper">
        <Avatar
          src={talentInfo?.profile_image ?? "/assets/Upstream.png"}
          className="profile-image"
          alt="Talent profile"
          sx={{ width: "100px", height: "100px" }}
        />
        <Box className="info-section">
          <Box className="username" sx={{ alignItems: "center" }}>
            <Typography component="h2" variant="h6">
              {`${userInfo.first_name} ${userInfo.last_name}`}
            </Typography>
            <Typography component="span" variant="body2">
              @{talentInfo.username}
            </Typography>
          </Box>

          <Box className="identifier-groups">
            <RatingNReview rating="4.6" reviews="15 reviews" />
            {Array.isArray(talentInfo.categories) && (
              <Box className="category">
                {talentInfo.categories.map((c) => (
                  <Box key={c}>{getCategoryLabel(c)}</Box>
                ))}
              </Box>
            )}
            <Box className="rank">
              <img src="/assets/bright_star.svg" alt="full_star" />
              <Typography component="span" variant="body2">
                Upcoming Star
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box className="edit-profile-buttons">
        {currentProfile?.id === talentInfo.id && (
          <Link
            href={`/talent/profile/edit/${talentInfo.id}`}
            className="edit-profile-button"
            underline="none"
          >
            <UserEditIcon style={{ fontSize: 20 }} /> Edit Talent Page
          </Link>
        )}

        <Button
          className="edit-profile-button"
          onClick={onShareClick}
          startIcon={<Icons.ShareIcon height={20} width={20} />}
        >
          Share Profile
        </Button>
      </Box>
    </Box>
  );
}
